import axios from 'axios'

const API_URL = process.env.VUE_APP_API_URL
const API_KEY = process.env.VUE_APP_API_KEY

const config = {}
config.baseURL = API_URL
if (API_KEY) {
  config.headers = {
    'X-ITAAM-API': API_KEY
  }
}

export default axios.create(config)
